<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BHFXkb/tc-custom/9781439677711.jpg?1704887003468" alt="This image is the cover for the book Rise of Napa Valley Wineries, The, American Palate"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rise of Napa Valley Wineries, The, American Palate
      </h1>
      <p class="bookDescription body article font2">
        <p>A wine country odyssey. <br/> In 1976, the picturesque, agrarian Napa Valley was all but unknown to those who didn't live there. That changed dramatically when Steven Spurrier and Patricia Gallagher decided to host a blind tasting of American and French wines in Paris. When wines from California defeated those of France, the world was shocked, an industry reawakened, and Napa Valley exploded in a frenzy of growth and development. Families who had farmed for generations battled to hang onto their land, and many paid a steep price as the area transformed into one of the world's premier wine-growing regions. <br/> Join author Mark Gudgel as he explores the trials and tribulations of Napa's meteoric rise to prominence.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Gudgel
      </h2>
      
      <p class="authorDescription body article">Dr. Mark Gudgel is a father, husband, college professor, marathon runner and author. A regular contributor to Edible Marin & Wine Country and Napa Valley Life , his previous book, Think Higher Feel Deeper , focused on his career in Holocaust education. He is the board president of the vinNEBRASKA Foundation and currently working on a book about the Court of Master Sommeliers and a travel guide to the Napa Valley. Gudgel lives in Omaha with his wife, Sonja, and their children, Zooey and Titus.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cd8a5a4c